var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"text"},[_vm._v("二维码已失效，请重新扫码")])])
}]

export { render, staticRenderFns }